import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { ConnectDialog, InfoDialog } from "../ExternalProvider/Dialogs";
import { RestAPI } from "@aws-amplify/api-rest/lib-esm/RestAPI";
import CeresImg from "../../img/external/ceresImg.png";
import floridaImg from "../../img/external/floridaImg.png";
import zentracloudImg from "../../img/external/zentracloudImg.png";
import arableImg from "../../img/external/arableImg.png";
import weenatImg from "../../img/external/weenatImg.png";
import irrimaxImg from "../../img/external/irrimaxImg.png";
import davisImg from "../../img/external/davisImg.png";
import SelfHelp from "../Utils/SelfHelp";
import { FarmContext } from "../../contexts/FarmContext";
import LoadingDialog from "../Utils/LoadingDialog";

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const ExternalProvider = ({ sectorsInfo }) => {
    const { t, i18n } = useTranslation();
    const [_, dispatch] = useContext(FarmContext);
    const [connectDialogState, setConnectDialogState] = useState({ visible: false});
    const [infoDialogState, setInfoDialogState] = useState({ visible: false });
    const [contador, setContador] = useState(0);
    const [data, setData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const location = useLocation();
    const farmId = getFarm(location);
    const acceso_limitado = dispatch({ type: "get", path: "accesoLimitado" });

    const typeToImage = {
        "CERES":CeresImg,
        "UFL":floridaImg,
        "ZENTRACLOUD":zentracloudImg,
        "ARABLE":arableImg,
        "WEENAT":weenatImg,
        "IRRIMAX":irrimaxImg,
        "DAVIS":davisImg
    };

    const nameInDisplay = {
        "CERES":"Ceres Imaging" ,
        "UFL": t("external.ufl"),
        "ZENTRACLOUD":"ZentraCloud",
        "ARABLE":"Arable",
        "WEENAT":"Weenat",
        "IRRIMAX":"Irrimax",
        "DAVIS":"Davis"
    };
    const enableMarketplace = false;
    const externalAllowed = enableMarketplace?["IRRIMAX","ARABLE","CERES"]:["IRRIMAX","ARABLE","CERES","UFL","DAVIS","ZENTRACLOUD","WEENAT"];
    const selfHelpConImg1 = import.meta.glob("../../img/autoayuda/*/autoayuda-external-provider-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-external-provider-1.png`];
    const selfHelpConImg2 = import.meta.glob("../../img/autoayuda/*/autoayuda-external-provider-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-external-provider-2.png`];
    const selfHelpConImg3 = import.meta.glob("../../img/autoayuda/*/autoayuda-external-provider-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-external-provider-4.png`];
    const selfHelpConImg4 = import.meta.glob("../../img/autoayuda/*/autoayuda-external-provider-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-external-provider-5.png`];
    const selfHelpConImg5 = import.meta.glob("../../img/autoayuda/*/autoayuda-external-provider-termino.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-external-provider-termino.png`];
    const selfHelpConImg6 = import.meta.glob("../../img/autoayuda/*/autoayuda-external-provider-card.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-external-provider-card.png`];

    const selfHelpConectados = [
        {
            tab: 1, header: { text: t("selfHelp.external.conectar.msgHeader") }, params:
                [
                    { id: 1, text: t("selfHelp.external.conectar.msgBtnPlus"), image: selfHelpConImg1 },
                    { id: 2, text: t("selfHelp.external.conectar.msgSelectExt"), image: selfHelpConImg2 },
                    { id: 3, text: t("selfHelp.external.conectar.msgLogin"), image: selfHelpConImg3 },
                    { id: 4, text: t("selfHelp.external.conectar.msgConnect"), image: selfHelpConImg4 },
                    { id: 5, text: t("selfHelp.external.conectar.msgChanges"), image: selfHelpConImg5 },
                ]
        },
        {
            tab: 2, header: { text: t("selfHelp.external.cards.msgHeader") }, params:
                [
                    { id: 1, text: t("selfHelp.external.cards.msgCard"), image: selfHelpConImg6 },
                ]
        }
    ];

    const openConnectDialog = () => {
        setConnectDialogState({
            data: data?.dataTipo,
            visible: true
        });
    };

    const openInfoDialog = (row) => {
        setInfoDialogState({
            dataUuid: row?.config?.uuidDynamo,
            config:row?.config,
            type: row?.tipo,
            create: row?.created_at,
            visible: true,
            external_provider_id: row?.external_provider_id,
            nombre_sector: row?.nombre_sector,
            tipo_sector: row?.tipo_sector,
            nodoId: row?.config?.nodo_id ?? row?.nodo_id
        });
    };

    useEffect(() => {
        setDataLoading(true);
        const param = `/external/${farmId}`;
        async function getTipoExternal() {
            RestAPI.get("apiAdminDropControl", param)
                .then(res => {
                    const response = JSON.parse(JSON.stringify(res));
                    const  filteredResCheck = response?.dataChek?.filter(e => externalAllowed.includes(e.tipo));
                    const  filteredResType = response?.dataTipo?.filter(e => externalAllowed.includes(e.tipo));
                    setData({dataChek:filteredResCheck, dataTipo:filteredResType});
                    setDataLoading(false);
                })
                .catch(err => { console.error(err); setDataLoading(false); });
        }
        getTipoExternal();
    }, [farmId, contador]);

    const dataCheck = data?.dataChek;

    return (
        <div className='row-container'>
            <div className='col-xl-12 col-lg-12 col-sm-12'>
                <ConnectDialog
                    dialogState={connectDialogState}
                    setDialogState={setConnectDialogState}
                    setContador={setContador}
                    dataCheck={dataCheck}
                    externalAllowed={externalAllowed}
                />
                <InfoDialog
                    dialogState={infoDialogState}
                    setDialogState={setInfoDialogState}
                    acceso_limitado={acceso_limitado}
                    setContador={setContador}
                    sectorsInfo={sectorsInfo}
                />
                <div id="cardDownload" className="card">
                    {dataLoading && <LoadingDialog appendTo="self" />}
                    <div className="card-body">
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4'>
                                {selfHelpConectados &&
                                    <SelfHelp t={t} lng={i18n.language} params={selfHelpConectados} fertiTable />}
                            </div>
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("external.external")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 text-right'>
                                {!acceso_limitado &&
                                <FontAwesomeIcon
                                    className='btnEdit pointer text-dark'
                                    size="lg"
                                    icon={faPlus}
                                    onClick={(e) => { openConnectDialog(); }}
                                />}
                            </div>
                        </div>

                        <div className='linea-titulo' />

                        <div className='row'>
                            {data?.dataChek && data?.dataChek?.map((row, index) => (
                                <div key={index} className='e-card' onClick={(e) => openInfoDialog(row) }>
                                    <div className="e-card-image" style={{ backgroundImage: `url(${typeToImage[row?.tipo] ?? CeresImg })` , width:"200px", height:"200px", alt: "" }}>
                                        <div className="e-card-title">
                                            {
                                                row?.tipo === "DAVIS" ? `${nameInDisplay[row?.tipo]} (V${row?.config?.version ?? 2})`
                                                    :
                                                    `${nameInDisplay[row?.tipo] ?? nameInDisplay["CERES"] }`
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExternalProvider;
